export default __webpack_public_path__ + "locales/pt/DataReassignmentDialog.json?hash=9c6f94a916a9b9f7ef8e4c1eab006304";